import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import { ToastContainer } from "react-toastify";

const isAuthenticated = () => {
  return !!localStorage.getItem("accessToken");
};

const ProtectedAdminRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/auth/login" replace />;
};

const ProtectedAuthRoute = ({ children }) => {
  return !isAuthenticated() ? children : <Navigate to="/admin/index" replace />;
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 1000,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Routes>
        <Route
          path="/admin/*"
          element={
            <ProtectedAdminRoute>
              <AdminLayout />
            </ProtectedAdminRoute>
          }
        />
        <Route
          path="/auth/*"
          element={
            <ProtectedAuthRoute>
              <AuthLayout />
            </ProtectedAuthRoute>
          }
        />
        <Route
          path="*"
          element={
            <Navigate
              to={isAuthenticated() ? "/admin/index" : "/auth/login"}
              replace
            />
          }
        />
      </Routes>
    </BrowserRouter>
    <ToastContainer />
  </QueryClientProvider>
);
